export default {
  IOT_MULTI_CONECT: 'IOT_MULTI_CONECT',
  IOT_INTERNET: 'IOT_INTERNET',
  IOT_MULTICONECT_M2M: 'IOT_MULTICONECT_M2M',
  MOT_MANAGER_OF_THINGS_ENTERPRISE: 'MOT_MANAGER_OF_THINGS_ENTERPRISE',
  ISIM: 'ISIM',
};
